import { instance } from "@/apis";
import { useMutation } from "@tanstack/react-query";

export const useCreateChatMemoMutation = () => {
  return useMutation({
    mutationFn: ({
      chatId,
      content,
      title,
      chatHistoryId,
    }: {
      chatId: string;
      content: string;
      title: string;
      chatHistoryId?: string;
    }) =>
      instance.post(`/api/df/user/chat/${chatId}/memo`, {
        content,
        title,
        chatHistoryId,
      }),
    onSuccess: (res) => {
      if (res.data.code.startsWith("S")) {
      } else {
        console.error("create chat memo error", res);
      }
    },
    onError: (err) => {
      console.error("create chat memo error", err);
    },
  });
};
